import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { transientOptions } from "shared/lib/styles";

import {
  StyledYouTube,
  VideoContainer,
} from "scmp-app/components/scmp-youtube-video/scmp-youtube-video-player/styles";

import { SCMPYouTubeVideoFooter } from "./scmp-youtube-video-footer";

type StyledSCMPYouTubeVideoFooterProps = {
  $orientation: "landscape" | "portrait";
};

export const StyledSCMPYouTubeVideoFooter = styled(SCMPYouTubeVideoFooter, {
  ...transientOptions,
})<StyledSCMPYouTubeVideoFooterProps>`
  ${props => {
    if (props.$orientation === "portrait") {
      return css`
        &&&& {
          inline-size: var(--portrait-inline-size);
          margin-inline: auto;
        }
      `;
    }
    switch (props.variant) {
      case "default":
        return css`
          display: flex;
        `;
    }
  }}
`;

type SCMPYoutubeVideoContainerProps = {
  $orientation: "landscape" | "portrait";
};

export const SCMPYoutubeVideoContainer = styled.div<SCMPYoutubeVideoContainerProps>`
  inline-size: 100%;
  block-size: auto;

  ${props =>
    props.$orientation === "portrait"
      ? css`
          ${VideoContainer} {
            aspect-ratio: 9 / 16;
          }
          ${StyledYouTube} {
            iframe {
              aspect-ratio: 9 / 16;
            }
          }
        `
      : css`
          ${VideoContainer} {
            aspect-ratio: 16 / 9;
          }
          ${StyledYouTube} {
            iframe {
              aspect-ratio: 16 / 9;
            }
          }
        `}
`;
